import { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { siteSlogan } from "@/mocks/guawa";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "热议专区" },
  { to: "/topic/discuss-2026", label: "讨论现场" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 bg-cream-50/90 backdrop-blur border-b border-cream-200">
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="今日曝瓜 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-water-flash-fill text-xl"></i>
          </span>
          <span className="leading-none">
            <span className="block text-base font-extrabold tracking-tight text-ink-900">今日曝瓜</span>
            <span className="block text-[10px] font-medium text-primary-600">吃瓜群众聚集地</span>
          </span>
        </Link>

        {/* 桌面导航 */}
        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  `rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? "bg-primary-500 text-white"
                      : "text-ink-600 hover:bg-primary-50 hover:text-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#site-topics"
            className="flex items-center gap-2 rounded-full border border-cream-300 bg-white px-4 py-2 text-sm text-ink-500 transition-colors hover:border-primary-200 hover:text-primary-700 whitespace-nowrap"
          >
            <i className="ri-search-line text-base"></i>
            <span>搜热点话题</span>
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-chat-3-line"></i>
            我要发言
          </Link>
        </div>

        {/* 移动端菜单按钮 */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-ink-700 transition-colors hover:bg-primary-50 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`}></i>
        </button>
      </nav>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-cream-200 bg-white px-4 py-3 md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `block rounded-lg px-3 py-2.5 text-sm font-medium whitespace-nowrap ${
                      isActive ? "bg-primary-500 text-white" : "text-ink-700 hover:bg-primary-50"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-semibold text-white whitespace-nowrap"
          >
            <i className="ri-chat-3-line"></i> 我要发言
          </Link>
        </div>
      )}

      {/* 面包屑（次级页面由各自页面渲染，这里记录用于高亮） */}
      <span className="sr-only">{siteSlogan} · {location.pathname}</span>
    </header>
  );
}